import { render, staticRenderFns } from "./SideMenuDb.vue?vue&type=template&id=1c946c0b"
import script from "./SideMenuDb.ts?vue&type=script&lang=ts&external"
export * from "./SideMenuDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports